import { TransactionStatus } from '../../types/donation/transaction-status'
import { TableField } from '../../types/table-field'
import { formatAmount } from '../../utils/strings/amount-format'
import { transactionStatusStrings } from '../../utils/strings/DonationStrings'
import { translations } from '../../utils/translations/translations-manager'

export const transactionFields: TableField[] = [
  {
    name: '_id',
    label: {
      it: 'ID',
      en: 'ID',
    },
    type: 'text',
    formattingRule: value => value as string,
  },
  {
    name: 'donationAmount',
    label: {
      it: 'Importo',
      en: 'Amount',
    },
    type: 'amount',
    formattingRule: value => formatAmount((value as number) / 100),
  },
  {
    name: 'createdAt',
    label: {
      it: 'Data',
      en: 'Date',
    },
    type: 'date',
    formattingRule: value => new Date(value).toLocaleString(translations.getLanguage()),
  },
  {
    name: 'stripePaymentIntentId',
    label: {
      it: 'ID Stripe',
      en: 'Stripe ID',
    },
    type: 'text',
    formattingRule: value => value as string,
  },
  {
    name: 'stripeDestinationPayment',
    label: {
      it: 'Stripe Destination ID',
      en: 'Stripe Destination ID',
    },
    type: 'text',
    formattingRule: value => value as string,
  },
  {
    name: 'transactionStatus',
    label: {
      it: 'Stato',
      en: 'Status',
    },
    type: 'text',
    formattingRule: value => transactionStatusStrings[value as TransactionStatus]?.() ?? value,
  },
]
